var React = require('react');

function TombstoneAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 192v224H64V192C64 86 150 0 256 0s192 86 192 192z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 464v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

TombstoneAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TombstoneAlt;

TombstoneAlt.default = TombstoneAlt;
